module.exports = __webpack_public_path__ + "img/reg_result_duigou.ebf176e0.png";